import { FC, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { deleteFirmware, firmwareList } from "../../actions/doctorActions";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";

export const FirmwareDeleteConfirmModal = ({
  show,
  handleClose,
  id,
  token,
}) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const deleteFirmwareItem = () => {
    setLoading(true);
    dispatch(deleteFirmware(token, id))
      .then((response) => {
        toast.success("Firmware deleted successfully");
        setLoading(false);
        dispatch(firmwareList(token))
          .then((response) => {})
          .catch((error) => {
            history.push("/firmware");
          });
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error Deleting firmware");
      });
    handleClose();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter">
            Firmware Delete Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this firmware?</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={deleteFirmwareItem}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
